var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9771 4.48595L10.1811 2.68995L8.88242 3.98928L10.6791 5.78595L11.9771 4.48595ZM3.39375 11.9973C3.37375 11.9993 3.35375 11.9999 3.33375 11.9999C3.15775 11.9999 2.98775 11.9306 2.86175 11.8046C2.72242 11.6646 2.65175 11.4699 2.66908 11.2733L2.92175 8.49328C2.94975 8.18861 3.08442 7.90061 3.30175 7.68395L9.29908 1.68661C9.76708 1.21661 10.6158 1.23995 11.1097 1.73261L12.9351 3.55795L12.9358 3.55861C13.4458 4.06928 13.4664 4.88128 12.9811 5.36795L6.98308 11.3659C6.76642 11.5826 6.47908 11.7173 6.17375 11.7453L3.39375 11.9973ZM3.33342 13.3335H12.6667C13.0334 13.3335 13.3334 13.6335 13.3334 14.0001C13.3334 14.3668 13.0334 14.6668 12.6667 14.6668H3.33342C2.96675 14.6668 2.66675 14.3668 2.66675 14.0001C2.66675 13.6335 2.96675 13.3335 3.33342 13.3335Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2027_3218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9771 4.48595L10.1811 2.68995L8.88242 3.98928L10.6791 5.78595L11.9771 4.48595ZM3.39375 11.9973C3.37375 11.9993 3.35375 11.9999 3.33375 11.9999C3.15775 11.9999 2.98775 11.9306 2.86175 11.8046C2.72242 11.6646 2.65175 11.4699 2.66908 11.2733L2.92175 8.49328C2.94975 8.18861 3.08442 7.90061 3.30175 7.68395L9.29908 1.68661C9.76708 1.21661 10.6158 1.23995 11.1097 1.73261L12.9351 3.55795L12.9358 3.55861C13.4458 4.06928 13.4664 4.88128 12.9811 5.36795L6.98308 11.3659C6.76642 11.5826 6.47908 11.7173 6.17375 11.7453L3.39375 11.9973ZM3.33342 13.3335H12.6667C13.0334 13.3335 13.3334 13.6335 13.3334 14.0001C13.3334 14.3668 13.0334 14.6668 12.6667 14.6668H3.33342C2.96675 14.6668 2.66675 14.3668 2.66675 14.0001C2.66675 13.6335 2.96675 13.3335 3.33342 13.3335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2027_3218)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.5794aa38d838a5efc9d2163d873fe9f7.svg";
export { ForwardRef as ReactComponent };